import * as React from "react";

export const IconBlock = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10ZM3.7 5.1L14.9 16.3C13.6 17.4 11.9 18 10 18C5.6 18 2 14.4 2 10C2 8.1 2.6 6.4 3.7 5.1ZM18 10C18 11.9 17.4 13.6 16.3 14.9L5.1 3.7C6.4 2.6 8.1 2 10 2C14.4 2 18 5.6 18 10Z"
      fill="#2E3436"
    />
  </svg>
);
